import { get, derived, writable } from 'svelte/store';
import configuration from './../stores/configuration';
import { getSubdomain } from '../helpers/domainHelper';
import _ from "lodash";
import { isEmpty } from '../helpers/objectHelper.js';

const supportedLocales = ['en-US', 'nb-NO', 'fr-FR'];
export const locale = navigator.languages.find(language => supportedLocales.includes(language)) ?? 'en-US';

/**
 * @param {string} _locale
 * @param {string} key
 * @param {Object} [vars]
 * @param {string} [fallback]
 * @returns {string}
 */
function translate(_locale, key, vars, fallback) {
  const config = get(configuration);
  if (!config[_locale] || _.isEmpty(config[_locale])) _locale = 'en-US';
  const translation = typeof config[_locale] === 'string' ? JSON.parse(config[_locale]) : config[_locale];
  if (!translation || isEmpty(translation)) throw new Error('translations are not available');
  if (!_locale) throw new Error('locale not provided');
  if (!key) throw new Error('no key provided to $t()');

  let text = translation[key] || fallback;

  if (!text) throw new Error(`no translation found for ${_locale}.${key}`);

  // Replace any passed in variables in the translation string
  Object.keys(vars).map((k) => {
    const regex = new RegExp(`{{${k}}}`, "g");
    text = text.replace(regex, vars[k]);
  });

  return text;
}

export const t = derived(writable(locale), ($locale) => (key, vars = {}, fallback = '') =>
  translate($locale, key, vars, fallback)
);

export const isPisa = getSubdomain().includes('-pisa-');